module.exports = __webpack_public_path__ + "assets/bf-be.72a75b05.svg";